import { WorkInjuryEmployerLiabilityBundle } from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import { ICoverageLimit } from "../../../services/api/insurance/monitorSettings/types";

export const selectorWorkersCompLimitMapper = (
  workersCompLimitMinimum?: WorkInjuryEmployerLiabilityBundle
) => {
  const limits: ICoverageLimit[] = [];
  if (!workersCompLimitMinimum) {
    console.error("No workers comp limit minimum provided/selected");
    return limits;
  }

  // Set limits by bundle
  let workersCompPerAcc = 0;
  let workersCompTotalForDisease = 0;
  let workersCompPerEmployeeDisease = 0;
  if (
    workersCompLimitMinimum ===
    WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred
  ) {
    workersCompPerAcc = 1000000;
    workersCompTotalForDisease = 500000;
    workersCompPerEmployeeDisease = 1000000;
  } else if (
    workersCompLimitMinimum ===
    WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred
  ) {
    workersCompPerAcc = 500000;
    workersCompTotalForDisease = 500000;
    workersCompPerEmployeeDisease = 500000;
  } else if (
    workersCompLimitMinimum ===
    WorkInjuryEmployerLiabilityBundle.OneMillionBundle
  ) {
    workersCompPerAcc = 1000000;
    workersCompTotalForDisease = 1000000;
    workersCompPerEmployeeDisease = 1000000;
  }

  limits.push(
    {
      limitType: "EmployersLiabilityEachAccident",
      amount: workersCompPerAcc,
      currency: "USD"
    },
    {
      limitType: "EmployersLiabilityDiseasePolicyLimit",
      amount: workersCompTotalForDisease,
      currency: "USD"
    },
    {
      limitType: "EmployersLiabilityDiseaseEachEmployee",
      amount: workersCompPerEmployeeDisease,
      currency: "USD"
    }
  );

  return limits;
};
